import cn from 'classnames';

import { IConDefaultType } from '../../types';

export interface IChargeIconProps extends IConDefaultType {}

export default function ChargeIcon({ color, className, size = 24, rotate, flip }: IChargeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7207_420668)">
          <path d="M8 10.5V19.5H12.5V18C12.5 17.2031 12.8164 16.4414 13.3789 15.8789L17 12.2578V10.5H8Z" fill="white" />
          <path
            d="M11.0001 0C9.50014 0 9.50014 1.5 9.50014 1.5V3H8.00014C8.00014 3 6.93959 2.97656 5.83217 3.5332C4.71889 4.08984 3.50014 5.50195 3.50014 7.5V19.5C3.50014 19.5 3.4767 20.5605 4.03334 21.6738C4.58998 22.7812 6.00209 24 8.00014 24H15.5001V21H8.00014C7.16811 21 6.50014 20.332 6.50014 19.5V7.5C6.50014 6.66797 7.16811 6 8.00014 6H17.0001C17.8322 6 18.5001 6.66797 18.5001 7.5V10.5H21.5001V7.5C21.5001 5.50195 20.2814 4.08984 19.174 3.5332C18.0607 2.97656 17.0001 3 17.0001 3H15.5001V1.5C15.5001 0 14.0001 0 14.0001 0L11.0001 0ZM20.0001 12V12.0117C19.6017 12.0059 19.2208 12.1641 18.9396 12.4395L14.4396 16.9395C14.1583 17.2207 14.0001 17.6016 14.0001 18V19.5H18.6994L17.2521 21.668C17.0939 21.9141 17.006 22.207 17.0119 22.5H17.0001V24H18.5001V23.9941C18.8986 23.9941 19.2794 23.8418 19.5607 23.5605L24.0607 19.0605C24.3419 18.7793 24.4943 18.3984 24.4943 18H24.5001V16.5H19.8068L21.2482 14.332C21.4123 14.0859 21.5001 13.793 21.5001 13.5V12H20.0001Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_7207_420668">
            <rect width="24" height="24" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
}
